// Bausteine (Leistungsblöcke): Suche, Markieren, Sortieren – EINE Stelle für Leiste im Beleg, eigenes Fenster, Handy und Einstellungen.
// Alles hier ist reine Rechnerei ohne Oberfläche.

// Umlaute/Groß-klein egal: je Zeichen genau EIN Zeichen (damit Treffer-Stellen im Originaltext passen)
const einZeichen = (ch) => {
  const base = ch.normalize("NFD").charAt(0);
  const l = base.toLowerCase();
  return l.length === 1 ? l : ch;
};
export const norm = (text) => {
  const s = String(text ?? "");
  let aus = "";
  for (let i = 0; i < s.length; i++) aus += einZeichen(s[i]);
  return aus;
};
export const suchWoerter = (q) => norm(q).split(/\s+/).filter(Boolean);

// Kurztext = erste Zeile, Langtext = der Rest (so steht es in jeder Beleg-Position)
export const kurzLang = (beschreibung) => {
  const t = String(beschreibung ?? "");
  const i = t.indexOf("\n");
  return i < 0 ? { kurz: t, lang: "" } : { kurz: t.slice(0, i), lang: t.slice(i + 1).replace(/^\s*\n/, "") };
};

// Text in Stücke teilen: [{ t, m }] – m = Treffer (gelb markieren)
export const markiere = (text, woerter) => {
  const s = String(text ?? "");
  if (!woerter?.length || !s) return [{ t: s, m: false }];
  const n = norm(s);
  const bereiche = [];
  for (const w of woerter) {
    let i = 0;
    while ((i = n.indexOf(w, i)) !== -1) { bereiche.push([i, i + w.length]); i += w.length; }
  }
  if (!bereiche.length) return [{ t: s, m: false }];
  bereiche.sort((a, b) => a[0] - b[0]);
  const fertig = [];
  for (const b of bereiche) {
    const letzter = fertig[fertig.length - 1];
    if (letzter && b[0] <= letzter[1]) letzter[1] = Math.max(letzter[1], b[1]); else fertig.push([...b]);
  }
  const aus = [];
  let pos = 0;
  for (const [a, e] of fertig) {
    if (a > pos) aus.push({ t: s.slice(pos, a), m: false });
    aus.push({ t: s.slice(a, e), m: true });
    pos = e;
  }
  if (pos < s.length) aus.push({ t: s.slice(pos), m: false });
  return aus;
};

const textName = (b) => norm(`${b.name || ""} ${(b.stichwoerter || []).join(" ")}`);
const textPositionen = (b) => norm((b.positions || []).map((p) => p.description || "").join("\n"));
export const trefferName = (b, woerter) => woerter.length > 0 && woerter.every((w) => textName(b).includes(w));
// alle Suchwörter kommen irgendwo vor (Name, Stichwörter, Kurz- oder Langtext)
export const passt = (b, woerter) => {
  if (!woerter.length) return true;
  const alles = `${textName(b)}\n${textPositionen(b)}`;
  return woerter.every((w) => alles.includes(w));
};
// Treffer im Text der Positionen (nicht nur im Namen)? – dann klappt die Karte von selbst auf
export const trefferInPositionen = (b, woerter) => woerter.length > 0 && woerter.some((w) => textPositionen(b).includes(w));

export const alleStichwoerter = (bloecke) => {
  const karte = new Map();
  for (const b of bloecke) for (const w of b.stichwoerter || []) { const k = norm(w); if (k && !karte.has(k)) karte.set(k, w); }
  return [...karte.values()].sort((a, b) => a.localeCompare(b, "de"));
};
export const hatStichwort = (b, wort) => (b.stichwoerter || []).some((w) => norm(w) === norm(wort));

export const SORTIERUNGEN = [
  ["zuletzt", "zuletzt benutzt"],
  ["haeufig", "häufig eingefügt"],
  ["name", "Name"],
  ["preis", "Preis"],
];
const zeit = (s) => (s ? Date.parse(s) || 0 : 0);
export const sortiere = (liste, art) => {
  const l = [...liste];
  const nameVergleich = (a, b) => (a.name || "").localeCompare(b.name || "", "de");
  const absteigend = (feld) => (a, b) => (b[feld] || 0) - (a[feld] || 0) || nameVergleich(a, b);
  if (art === "name") return l.sort(nameVergleich);
  if (art === "haeufig") return l.sort(absteigend("anzahl_benutzt"));
  if (art === "preis") return l.sort(absteigend("summe_netto"));
  return l.sort((a, b) => zeit(b.zuletzt_benutzt) - zeit(a.zuletzt_benutzt) || zeit(b.created_at) - zeit(a.created_at));   // zuletzt benutzt
};

export const euro = (n) => `${Number(n || 0).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
export const zahl = (n) => Number(n || 0).toLocaleString("de-DE", { maximumFractionDigits: 3 });
export const datumKurz = (iso) => { const t = zeit(iso); return t ? new Date(t).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit" }) : ""; };

// Titel-Gruppe: der Titel und alle Positionen bis zum nächsten Titel
export const gruppeVon = (positionen, titelIdx) => {
  const ids = [titelIdx];
  for (let i = titelIdx + 1; i < positionen.length && positionen[i].type !== "titel"; i++) ids.push(i);
  return ids;
};
export const anzahlPositionen = (b) => (b.positions || []).length;

// Nummern ergeben sich aus der Reihenfolge; Titel bleiben Titel
export const fuerBeleg = (positionen, ab) => positionen.map((p, i) => ({ ...p, pos_nr: p.type === "titel" ? 0 : ab + i + 1 }));
